import { AfterViewInit, ChangeDetectionStrategy, Component, computed, DestroyRef, effect, ElementRef, HostListener, inject, input, untracked, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'pbir-datatooltip',
  template: `
    @if (dataTooltip().headers?.length) {
      <div class="pbir-datatooltip-headers">
        <div class="pbir-datatooltip-header">
          @for (h of dataTooltip().headers; track h) {
            <span class="pbir-datatooltip-name">
              <span>{{h.name}}<span class="pbir-datatooltip-name-colon">:</span></span>
            </span>
            <span class="pbir-datatooltip-value">{{h.value}}</span>
          }
        </div>
      </div>
    }
    @if (dataTooltip().columns?.length || dataTooltip().rows?.length) {
    <div class="pbir-datatooltip-body">
      <div class="pbir-datatooltip-rows">
        @if (dataTooltip().columns?.length) {
          @for (c of dataTooltip().columns; track $index) {
            <div class="pbir-datatooltip-column">
              <span class="pbir-datatooltip-name">
                <span>{{c.name}}</span>
              </span>
              @for (v of c.values; track $index) {
                <span class="pbir-datatooltip-value">{{v}}</span>
              }
            </div>
          }
        }

        @if (dataTooltip().rows?.length) {
        @for (r of dataTooltip().rows; track $index) {
          <div class="pbir-datatooltip-row"
               [class.pbir-datatooltip-row-emphasis]="r.style == DataTooltipRowStyle.Emphasis"
               [class.pbir-datatooltip-row-change]="r.style == DataTooltipRowStyle.Change">
            <span class="pbir-datatooltip-name">
              @if (r.color) {
                <span class="pbir-datatooltip-symbol" [style.backgroundColor]="r.color"></span>
              }
              <span class="pbir-datatooltip-name-text">
                <span>{{r.name}}</span>
                @if (r.nameSuffix) {
                  <span>{{r.nameSuffix}}</span>
                }
              </span>
            </span>
            @for (v of r.values; track $index) {
              <span class="pbir-datatooltip-value">{{v}}</span>
            }
          </div>
        }
        }

        @if (dataTooltip().remainingRowCount) {
          <div class="pbir-datatooltip-row" style="color: rgba(99, 99, 99, 1)">
            <span class="pbir-datatooltip-name">
              <span>{{dataTooltip().remainingRowCount}} more...</span>
            </span>
            <span></span>
          </div>
        }

      </div>
    </div>
    }
    `,
  styles: `
    pbir-datatooltip {
      opacity: 0;
      pointer-events: none;
      user-select: none;
      display: block;
      border-radius: 4px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.45);
      font-size: 12px;
      white-space: nowrap;
      border: thin solid #2e2e2e;
      box-sizing: border-box;

      position: relative;
      left: 25px !important;
      top: -5px !important;

      &.pbir-datatooltip-fromRight {
        left: -25px !important;
        transform: translate(-100%, 0);
      }
      
      &.pbir-datatooltip-fromBottom {
        top: 5px !important;
        transform: translate(0, -100%);
      }

      &.pbir-datatooltip-fromBottom.pbir-datatooltip-fromRight {
        transform: translate(-100%, -100%);
      }

      .pbir-datatooltip-headers {
        background-color:rgba(46, 46, 46, 1);
        color: white;
        background: #2e2e2e;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        padding: 5px 10px;
        box-sizing: border-box;

        .pbir-datatooltip-name {
          font-weight: bold;
        }
      }

      .pbir-datatooltip-body {
        color: #2e2e2e;
        background: white;
        border-radius: 4px;
        padding: 5px 10px;
        padding-bottom: 10px;
        box-sizing: border-box;
      }

      .pbir-datatooltip-headers + .pbir-datatooltip-body {
        border-radius: 0;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }
      
      .pbir-datatooltip-headers,
      .pbir-datatooltip-rows {
        width: 100%;
        overflow: hidden;
        display: grid;
        grid-template-columns: auto auto;
        row-gap: 3px;
        column-gap: 5px;
      }
      
      .pbir-datatooltip-headers {
        grid-template-columns: max-content 1fr;
      }
      
      .pbir-datatooltip-rows {
        column-gap: 10px;
      }

      .pbir-datatooltip-column {
        font-weight: bold;
      }

      .pbir-datatooltip-header,
      .pbir-datatooltip-column,
      .pbir-datatooltip-row { display: contents; }

      .pbir-datatooltip-column > span {
        padding-bottom: 5px;
        border-bottom: thin solid rgba(151, 151, 151, 1);
      }

      .pbir-datatooltip-row:first-child > span {
        margin-top: 5px;
      }

      .pbir-datatooltip-symbol {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 5px;
        margin-left: 0px;
        line-height: 10px;
        display: inline-block;
      }

      .pbir-datatooltip-name,
      .pbir-datatooltip-value {
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .pbir-datatooltip-header .pbir-datatooltip-name {
        position: relative;
        overflow: hidden;

        > span {
          overflow: hidden;
          text-overflow: ellipsis;
          width: fit-content;
          display: block;
          position: relative;
          padding-right: 2px;
        }

        .pbir-datatooltip-name-colon {
          position: absolute;
          right: 0;
          top: 0;
        }
      }

      .pbir-datatooltip-column,
      .pbir-datatooltip-row {
        .pbir-datatooltip-value {
          text-align: right;
          padding-left: 20px;
        }
      }

      .pbir-datatooltip-row.pbir-datatooltip-row-emphasis {
        font-weight: bold;
      }

      .pbir-datatooltip-row.pbir-datatooltip-row-change {
        font-weight: bold;

        > span { 
          padding-top: 5px;
          border-top: thin solid rgba(151, 151, 151, 1);
        }
      }
      
      .pbir-datatooltip-row.pbir-datatooltip-row-change {
        .pbir-datatooltip-name {
          display: inline-flex;
        }

        .pbir-datatooltip-name-text {
          display: inline-flex;
          justify-content: space-between;
          flex: 1;
        }
      }
    }
    `,
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  host: {
    '[style.width]': 'maxWidthPx()',
  }
})
export class DataTooltipComponent implements AfterViewInit {
  readonly DataTooltipRowStyle = DataTooltipRowStyle;

  readonly dataTooltip = input.required<DataTooltip>();

  readonly maxWidthPx = computed(() => {
    let headerLengths = this.dataTooltip()?.headers?.map(x => x.name.length) ?? [];
    let columnLengths = this.dataTooltip()?.columns?.map(x => x.name.length) ?? [];
    let rowLengths    = this.dataTooltip()?.rows?.map(x => x.name.length + (x.nameSuffix?.length ?? 0)) ?? [];

    let lengths: number[] = [];

    if (headerLengths || columnLengths || rowLengths) {
      lengths = [...headerLengths, ...columnLengths, ...rowLengths].flat();
    }
    else {
      let rowValueLengths = this.dataTooltip()?.rows?.flatMap(x => x.values.map(y => y.length));
      if (rowValueLengths)
        lengths = rowValueLengths;
    }

    let maxLength = lengths.reduce((x, n) => Math.max(x, n), 20);

    if (!maxLength || isNaN(maxLength))
      maxLength = 0;

    let maxWidth =
      (maxLength <= 20) ? 250 :
      (maxLength <= 32) ? 300 : 350;

    return `${maxWidth}px`;
  });

  readonly element: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);
  readonly destroyRef = inject(DestroyRef);

  private readonly checkPositionAfterChange = effect(() => {
    let _ = [this.dataTooltip(), this.maxWidthPx()];
    untracked(() => this.checkPosition());
  });

  private checkPosition() {
    let margin = 10;
    let viewport = document.documentElement.getBoundingClientRect();

    this.element.nativeElement.classList.remove('pbir-datatooltip-fromRight');
    this.element.nativeElement.classList.remove('pbir-datatooltip-fromBottom');

    let rect = this.element.nativeElement.getBoundingClientRect();

    if (rect.width) {
      let swapX = rect.right >= (viewport.right - margin);
      this.element.nativeElement.classList.toggle('pbir-datatooltip-fromRight', swapX);
    
      let swapY = rect.bottom >= (viewport.bottom - margin);
      this.element.nativeElement.classList.toggle('pbir-datatooltip-fromBottom', swapY);

      // Element is initially hidden until the first time we get its position checked
      this.element.nativeElement.style.setProperty('opacity', '1', 'important');
    }
  };

  ngAfterViewInit() {
    this.checkPosition();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    this.checkPosition();
  }
}

export interface DataTooltip {
  readonly headers?: ReadonlyArray<DataTooltipHeader>;
  readonly columns?: ReadonlyArray<DataTooltipColumn>;
  readonly rows?: ReadonlyArray<DataTooltipRow>;
  readonly remainingRowCount?: number;
}

export interface DataTooltipHeader {
  readonly name: string;
  readonly value: string;
}

export interface DataTooltipColumn {
  readonly name: string;
  readonly values: ReadonlyArray<string>;
}

export interface DataTooltipRow {
  readonly color?: string;
  readonly name: string;
  readonly nameSuffix?: string;
  readonly values: ReadonlyArray<string>;
  readonly style?: DataTooltipRowStyle;
}

export enum DataTooltipRowStyle {
  Default,
  Emphasis,
  Change
}
